import { axios } from '@Root/API'

export const remove = (contactId, relationshipId) => {
	return axios.delete(`contacts/relation/${contactId}/${relationshipId}`)
}
